import React from 'react';

export const Sync = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.6185 14.6667C19.5097 14.9719 19.3829 15.2686 19.2391 15.5556C17.9197 18.1897 15.1799 20 12.014 20C7.86365 20 4.44567 16.8888 4 12.8889M4.39875 9.36401C5.49688 6.24081 8.4917 4 12.014 4C16.0869 4 19.4545 6.99604 20 10.888"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M17.0136 10.1587L20.3209 11.5947L22.9184 9.09407"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M7.29222 14.1521L3.96593 12.7607L1.40229 15.296"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
